import { validatorAttachment } from "../../../companies/attachments";
import { validatorTag, validatorEntityTag } from "../../../companies/tags";
import type { DomainGroup, TableScope } from "../types";

export const documentsDomain: DomainGroup = {
  id: "documents",
  name: "Documentos",
  description: "Gestion de documentos, plantillas y archivos adjuntos",
  icon: "FileText",
  order: 6,
  status: "inactive",
  modules: [
    {
      id: "attachments",
      name: "Archivos Adjuntos",
      description: "Gestion de archivos e imagenes adjuntas a entidades",
      icon: "Paperclip",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: [],
      navigation: {
        showInNav: false,
        contexts: [],
        navOrder: 3,
        status: "coming-soon",
      },
      tables: [
        {
          tableName: "attachments",
          schema: validatorAttachment,
          scope: "branch" as TableScope,
          relations: [],
          searchFields: ["name", "description"],
          hasStatusIndex: false,
          searchIndex: { name: "search_attachments", field: "name" },
        },
      ],
      readOnlyTables: [{ tableName: "clients" }],
    },
    {
      id: "tags",
      name: "Etiquetas",
      description: "Sistema de etiquetas global para busqueda y organizacion",
      icon: "Tag",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: [],
      navigation: {
        showInNav: false,
        contexts: [],
        navOrder: 4,
        status: "coming-soon",
      },
      tables: [
        {
          tableName: "tags",
          schema: validatorTag,
          scope: "branch" as TableScope,
          relations: [],
          searchFields: ["name", "slug"],
          hasStatusIndex: false,
          searchIndex: { name: "search_tags", field: "name" },
        },
        {
          tableName: "entity_tags",
          schema: validatorEntityTag,
          scope: "branch" as TableScope,
          relations: [
            {
              key: "tag",
              sourceField: "tagId",
              schema: validatorTag,
              tableName: "tags",
            },
          ],
          searchFields: [],
          hasStatusIndex: false,
        },
      ],
      readOnlyTables: [],
    },
  ],
};
